import { render, staticRenderFns } from "./DraftDegreeDetail.vue?vue&type=template&id=25e95c6a&scoped=true&"
import script from "./DraftDegreeDetail.vue?vue&type=script&lang=js&"
export * from "./DraftDegreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e95c6a",
  null
  
)

export default component.exports